import NfeEmissionConfigContainer from './NfeEmissionConfigContainer'

export default function NfeEmissionConfigScreen() {
    return <NfeEmissionConfigContainer />
}
